import React, {Component, Fragment,} from 'react'
import {message, Tabs, Timeline} from 'antd'
import {getOrderTrails} from '../../api'
import {ReactBingmaps} from 'react-bingmaps'
import moment from 'moment';
moment.locale('zh-cn');

const {TabPane} = Tabs;

export default class Gps extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bingmapKey: "AuXjIRtmvSChnWxFOVerDnOU8EZyQ-LXI-w9zsxkmEYFR9DmScWoZFM88YcTw6uv",
            center: [],
            infoboxesWithPushPins: [],
            polyline: {"location": [], "option": {strokeColor: '', strokeThickness: 0}},
            stepDescriptions: [],
        }
    }

    tabChange = (key) => {
        const trailNo = key.split(',')[0];
        const factoryCode = key.split(',')[1];
        this.getOrderTrails(trailNo, factoryCode);
        this.getRightOrderTrails(trailNo, factoryCode);
    };
    getOrderTrails = async (trailNo, factoryCode) => {
        if (trailNo) {
            let result = await getOrderTrails({trailNo, factoryCode, type: 'normal', orderId: this.props.orderId});
            if (result.code === 200 && result.data.length > 0) {
                let ret = [];
                let ret2 = [];
                result.data.forEach((item) => {
                    let address =
                        '位置:' + item.address + '<br/>' +
                        '设备号:' + item.trailNo + '<br/>' +
                        '到达时间:' + item.activeDt + '<br/>' +
                        '经度:' + item.longitude + '<br/>' +
                        '纬度:' + item.latitude + '<br/>' +
                        '温度(摄氏):' + item.uTemperature + '<br/>' +
                        '电量(%):' + item.uBattery + '<br/>' +
                        '信号强度:' + item.uSignalstrength;
                    ret.push({
                        "location": [item.latitude, item.longitude],
                        "addHandler": "mouseover",
                        "infoboxOption": {title: "", description: address, maxHeight: 300, maxWidth: 420},
                        "pushPinOption": {title: "", description: "", color: 'DodgerBlue'},
                        "infoboxAddHandler": {
                            "type": "click", callback: () => {
                                this.scrollInto("step" + item.id)
                            }
                        },
                        "pushPinAddHandler": {
                            "type": "click", callback: () => {
                                this.scrollInto("step" + item.id)
                            }
                        }
                    });
                    ret2.push([item.latitude, item.longitude])
                });
                this.setState({
                    center: ret2[0],
                    infoboxesWithPushPins: ret,
                    polyline: {"location": ret2, "option": {strokeColor: 'DodgerBlue', strokeThickness: 4}},
                });
            }
            if (result.code !== 200) {
                message.error(result.message)
            }
        }
    };
    timer_two = (trailNo, factoryCode) => setTimeout(() => {
        this.getOrderTrails(trailNo, factoryCode)
    }, 2000);
    getRightOrderTrails = async (trailNo, factoryCode) => {
        if (trailNo) {
            let result = await getOrderTrails({trailNo, factoryCode, type: 'all', orderId: this.props.orderId});
            if (result.code === 200 && result.data.length > 0) {
                let description = [];
                result.data.forEach(function (item) {
                    let sesObj = {
                        id: item.id,
                        sts: item.sts,
                        activeDt: item.activeDt,
                        address: item.address,
                        latitude: item.latitude,
                        longitude: item.longitude,
                        uTemperature: item.uTemperature,
                        uSignalstrength: item.uSignalstrength

                    };
                    description.push(sesObj)
                });
                this.setState({
                    stepDescriptions: description
                });
            } else if (result.code === 200) {
                this.setState({
                    stepDescriptions: []
                });
            } else {
                message.error(result.message)
            }
        }
    };
    stepDescription = (obj) => {
        if (obj) {
            return <div>
                <div>{obj.activeDt}</div>
                <div>{obj.address}</div>
                <div>经度:{obj.longitude}</div>
                <div>纬度:{obj.latitude}</div>
                <div>温度(摄氏):{obj.uTemperature}</div>
                <div>信号强度:{obj.uSignalstrength}</div>
            </div>
        }
    };
    handleClickItem = (des) => {
        if (des.sts === 'Y') {
            this.scrollInto("step" + des.id);
            this.setState({
                center: [des.latitude, des.longitude],
                regularPolygons: [
                    {
                        "center": [des.latitude, des.longitude],
                        "radius": 6,
                        "points": 6,
                        "option": {fillColor: "rgba(0,0,0,0.4)", strokeThickness: 2}
                    }
                ],
            });
        }
    };
    scrollInto = (id) => {
        let anchorElement = document.getElementById(id);
        if (anchorElement) {
            this.setState({activeId: id,});
            anchorElement.scrollIntoView({block: "start", inline: "start"});
        } else {
            console.log(id + " not found")
        }
    };

    componentDidUpdate(preProps, preState, snapShot) {
        const {mapData} = this.props;
        if (Array.isArray(mapData) && mapData.length > 0 && Array.isArray(preProps.mapData) && preProps.mapData.length === 0) {
            this.getRightOrderTrails(mapData[0].trailNo, mapData[0].factoryCode);
            this.timer_two(mapData[0].trailNo, mapData[0].factoryCode);
        }
    }

    render() {
        const {mapData} = this.props;
        const {stepDescriptions} = this.state;
        return (
            <Fragment>
                {mapData ? <Tabs type="card" style={{marginTop: '10px'}} onChange={this.tabChange}>
                    {mapData.map(t => {
                        return t.trailNo ?
                            <TabPane tab={t.trailNo} key={t.trailNo + ',' + t.factoryCode}></TabPane> : ''
                    })}
                </Tabs> : null}
                <div className='track-map-box '>
                    <div className="track-step-map" id="bingmap">
                        <ReactBingmaps
                            zoom={8}
                            center={this.state.center}
                            bingmapKey={this.state.bingmapKey}
                            polyline={this.state.polyline}
                            infoboxesWithPushPins={this.state.infoboxesWithPushPins}
                            regularPolygons={this.state.regularPolygons}
                        >
                        </ReactBingmaps>
                    </div>
                    <div className='track-map-list'>
                        {stepDescriptions ? <Timeline>
                            {stepDescriptions.map(des => (
                                <Timeline.Item id={"step" + des.id} key={"step" + des.id}><p
                                    onClick={() => this.handleClickItem(des)}
                                    style={this.state.activeId === ("step" + des.id) ? {
                                        color: "#2975d5",
                                        paddingTop: 3
                                    } : (des.sts !== 'N' ? {
                                        color: "rgba(0, 0, 0, 0.9)",
                                        paddingTop: 3
                                    } : {color: "rgba(0,0,0,.45)", paddingTop: 3})}>{this.stepDescription(des)}</p>
                                </Timeline.Item>
                            ))}
                        </Timeline> : null}
                    </div>
                </div>
            </Fragment>

        )
    }
}